var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tooltip',{attrs:{"content":_vm.pointsForUser,"placement":"top"}},[_c('Avatar',{staticClass:"author-avatar",style:(_vm.avatarStyle),attrs:{"src":_vm.author.imageUrl,"size":_vm.size}},[_vm._v(" "+_vm._s(_vm.authorInitial)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }